import React, { useState } from "react";
import { FieldControl } from "react-reactive-form";
import { CFormInput } from "@coreui/react";

const NumericInput = ({
  name,
  disabled = false,
  className = "",
  placeholder = "",
  ...props
}) => {
  const [error, setError] = useState("");
  const [isValid, setIsValid] = useState(true);

  // Check if this field needs percentage symbol
  const needsPercentageSymbol = [
    "qCutOffsForAdverseEventsTables",
    "qCutOffsForDemographicsTables",
    "qCutOffsForAbnormalLabTables",
  ].includes(name);

  // Regex for whole numbers and within the range of 0-100
  const numericRegex = /^(100|[1-9][0-9]?|0)$/;

  const validateNumericInput = value => {
    if (!value) {
      setError("");
      setIsValid(true);
      return true;
    }

    if (!numericRegex.test(value)) {
      setError("Only whole numbers allowed and within the range of 0 to 100.");
      setIsValid(false);
      return false;
    }

    setError("");
    setIsValid(true);
    return true;
  };

  const handleChange = (e, controlOnChange) => {
    const value = e.target.value;

    // Allow empty value, single decimal point, or valid numeric input
    if (value === "" || value === "." || numericRegex.test(value)) {
      if (controlOnChange) controlOnChange(e);
      validateNumericInput(value);
    }
    // If invalid, don't update the input but still validate
    else {
      validateNumericInput(value);
    }
  };

  const handleBlur = (e, controlOnBlur) => {
    const value = e.target.value;
    validateNumericInput(value);
    if (controlOnBlur) controlOnBlur(e);
  };

  return (
    <div className="numeric-input-container">
      <FieldControl
        name={name}
        render={({ handler }) => {
          // handler() returns { value, onChange, onBlur, ... } - must use this so the form control is updated
          const controlProps = handler();
          return (
            <div className="input-with-percentage-wrapper">
              <CFormInput
                className={`input-text ${disabled ? "disabled" : ""} ${className} ${
                  !isValid ? "input-error" : ""
                } ${needsPercentageSymbol ? "input-with-percentage" : ""}`}
                type="number"
                name={name}
                readOnly={disabled}
                inputMode="numeric"
                placeholder={placeholder}
                value={controlProps.value ?? ""}
                onChange={e => handleChange(e, controlProps.onChange)}
                onBlur={e => handleBlur(e, controlProps.onBlur)}
                {...props}
              />
              {needsPercentageSymbol && (
                <span className="percentage-symbol">%</span>
              )}
            </div>
          );
        }}
      />
      {error && <div className="error-message">{error}</div>}
    </div>
  );
};

export default NumericInput;
